import { invertMap } from '@/sections/insights/queryBuilder/entities/common/invert';
import {
  getNotFromSimpleFilter,
  getOperatorFromQueryFilter,
  getOperatorFromSimpleFilter,
  getValueFromQueryFilter,
  getValueFromSimpleFilter,
} from '@/sections/insights/queryBuilder/entities/common/translators';
import type {
  SimpleFilter,
  SimpleFilterDefinition,
} from '@/sections/insights/queryBuilder/entities/types';
import type { QueryFilter } from '@/types';

const valueMap: Record<string, string> = {
  account: 'Integration',
  seed: 'Seed',
  self: 'Praetorian',
};

const valueMapInverse = invertMap(valueMap);

/**
 * Reusable field definition for Asset source
 * Pass-through translation (no value mapping needed)
 */
export const AssetSource: SimpleFilterDefinition = {
  apiField: 'source',
  uiField: 'Source',
  inputType: 'dropdown',
  getAvailableValues: () =>
    Promise.resolve(['Integration', 'Seed', 'Praetorian']),
  operators: ['is', 'is not'],

  translateForUI: (queryFilter: QueryFilter): SimpleFilter => {
    return {
      field: 'Source',
      operator: getOperatorFromQueryFilter(queryFilter),
      value: getValueFromQueryFilter(valueMap, queryFilter),
    };
  },

  translateForAPI: (simpleFilter: SimpleFilter): QueryFilter => {
    return {
      field: 'source',
      operator: getOperatorFromSimpleFilter(simpleFilter),
      value: getValueFromSimpleFilter(valueMapInverse, simpleFilter),
      not: getNotFromSimpleFilter(simpleFilter),
    };
  },
};
